module.exports = __webpack_public_path__ + "media/images/pa_landscape_logo-e4232d91cfb3f3d9f02d4dc1ce8c520d.svg";